function traslateCopy (data) {
  this.copyId = data.attributes?.copyId;
  this.text = data.attributes?.text;
}

export default traslateCopy;